import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown as Dd } from 'primereact/dropdown';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';
import useGetListAPI from 'modules/intakeforms/hooks/useGetListAPI';

export default function PracticeArea({ handleSettingsClick, item, index, isFormBuilder, isFromPreview = false }) {
  const { practiceAreaList } = useGetListAPI();

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const { subtext, label, required } = item || {};
  const name = `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field, fieldState }) => (
            <Dd
              id={field.name}
              options={practiceAreaList || []}
              optionLabel="practice_area_name"
              optionValue="practice_area_id"
              onChange={(e) => {
                field.onChange(e.value);
                const label = practiceAreaList?.find((item) => item?.practice_area_id === e?.value)?.practice_area_name;
                setValue(`form_data.${index}._practice_area_`, label);
              }}
              value={field.value}
              placeholder="Select"
              className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              inputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
